// Reorder array to work with react-slick multiple rows layout
const reorderArray = (arr, rows) => {
  if (arr.length < 7 || rows !== 2) return arr
  const result = []
  const groups = []
  const groupSize = 6

  for (let i = 0; i < arr.length; i += groupSize) {
    groups.push(arr.slice(i, i + groupSize))
  }

  groups.forEach((group) => {
    const firstHalf = group.slice(0, Math.ceil(group.length / 2))
    const secondHalf = group.slice(Math.ceil(group.length / 2))

    firstHalf.forEach((item, index) => {
      result.push(item)
      if (secondHalf[index]) result.push(secondHalf[index])
    })
  })
  return result
}

export { reorderArray }
